import { render, staticRenderFns } from "./PuiMenuIconBottomBar.vue?vue&type=template&id=0d21a436&scoped=true&"
import script from "./PuiMenuIconBottomBar.vue?vue&type=script&lang=js&"
export * from "./PuiMenuIconBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./PuiMenuIconBottomBar.vue?vue&type=style&index=0&id=0d21a436&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21a436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNavigation,VBtn,VIcon,VSpacer})
